import { render, staticRenderFns } from "./pageOne.vue?vue&type=template&id=ddf064b4&scoped=true&"
import script from "./pageOne.vue?vue&type=script&lang=js&"
export * from "./pageOne.vue?vue&type=script&lang=js&"
import style0 from "./pageOne.vue?vue&type=style&index=0&id=ddf064b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf064b4",
  null
  
)

export default component.exports